import __request__ from 'routing/request';
interface ProxiedResource__CallResult_VoidMap {
    readonly [_key: string]: ProxiedResource__CallResult_Void;
}
interface ProxiedResource__NodeResponse_Void {
    readonly error_text: string;
    readonly code: number;
    readonly success: boolean;
    readonly entity: null;
}
interface ProxiedResource__CallResult_Void {
    readonly response: ProxiedResource__NodeResponse_Void;
    readonly server_error_message: string;
    readonly call_executed: boolean;
}
/**
 * Purge Lookup Table Cache on the cluster-wide level
 */
export function performPurge(idOrName?: string, key?: string): Promise<ProxiedResource__CallResult_VoidMap> {
    return __request__('POST', `/cluster/system/lookup/tables/${idOrName}/purge`, null, { 'key': key }, {
        'Accept': ['application/json']
    });
}
